import { StreamChat } from 'stream-chat';

let chatClient = null;

export function getChatClient() {
  return chatClient;
}

export async function initChatClient(user, userToken, userChatId) {
  const apiKey = process.env.REACT_APP_STREAM_API_KEY;
  if (!apiKey) {
    console.warn('REACT_APP_STREAM_API_KEY not set; cannot init Stream client');
    throw new Error('STREAM_API_KEY_MISSING');
  }

  if (!chatClient) {
    chatClient = StreamChat.getInstance(apiKey);
  }

  if (user && userToken) {
    try {
      await chatClient.connectUser(
        {
          id: userChatId,
          name: user.fullName || user.full_name || user.email || `user-${user.id}`,
          fullName: user.fullName || user.full_name,
          image: user.originProfilePhotoS3Url || null,
          isVerified: user.isVerifiedByBuddiAdmin,
        },
        userToken
      );
    } catch (err) {
      console.error('Failed to connect Stream user', err);
      throw err;
    }
  }

  return chatClient;
}

export async function disconnectChatClient() {
  if (!chatClient) return;
  try {
    // disconnectUser will cleanly close connections
    await chatClient.disconnectUser();
  } catch (err) {
    console.warn('Error while disconnecting Stream client', err);
  } finally {
    chatClient = null;
  }
}

export default {
  initChatClient,
  getChatClient,
  disconnectChatClient,
};
